import React, { useMemo } from 'react';
import { IonSpinner, IonText } from '@ionic/react';
import ActionGrid from '@/components/common/ActionGrid';
import { InspectionGridRow } from '@/types/model/inspection';
import {
  buildInspectionActionGridActionColumns,
  buildInspectionActionGridBulkActions,
  buildInspectionActionGridColumns,
  buildInspectionActionGridData,
} from '@/services/util/adapters/InspectionActionGridAdapter';

interface InspectingGridViewProps {
  rows: InspectionGridRow[];
  loading: boolean;
  canAddNew: boolean;
  onEdit: (row: InspectionGridRow) => void;
  onAddNew: () => void;
  onSwitchToAccordion: () => void;
}

const InspectingGridView: React.FC<InspectingGridViewProps> = ({
  rows,
  loading,
  canAddNew,
  onEdit,
  onAddNew,
  onSwitchToAccordion,
}) => {
  const columns = useMemo(() => buildInspectionActionGridColumns(), []);
  const gridData = useMemo(() => buildInspectionActionGridData(rows), [rows]);
  const actionColumns = useMemo(
    () => buildInspectionActionGridActionColumns({ rows, onEdit }),
    [rows, onEdit]
  );
  const bulkActions = useMemo(
    () => buildInspectionActionGridBulkActions({ canAddNew, onAddNew, onSwitchToAccordion }),
    [canAddNew, onAddNew, onSwitchToAccordion]
  );

  if (loading) {
    return (
      <div className="loading-state">
        <IonSpinner name="crescent" />
        <IonText color="medium">
          <p>Loading inspections...</p>
        </IonText>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', height: 'calc(100vh - 170px)' }}>
      <ActionGrid
        columns={columns}
        gridData={gridData}
        actionColumns={actionColumns}
        bulkActions={bulkActions}
        defaultColDef={{ resizable: true, sortable: true, filter: true, minWidth: 90 }}
        overlayNoRowsTemplate="No inspections found."
      />
    </div>
  );
};

export default InspectingGridView;
